export default {
    seguTimer: 0,
    muguTimer: 0,
    setenTimer: 0,
    mutenTimer: 0,
    guruApproveTimer: 0,
    guruQueueTimer: 0,
    tendikApproveTimer: 0,
    tendikQueueTimer: 0,
    gukelTimer: 0,
    segukelTimer: 0,
    tenkelTimer: 0,
    setenkelTimer: 0,
    semuguTimer: 0,
    semutenTimer: 0
}